import React from 'react';

const QuickFit = ({ quickFitText, showFitPrefix = true }: { quickFitText: string; showFitPrefix?: boolean }) => {
  return (
    <p className="quickFitText body">
      {showFitPrefix && <span className="body bold mr-2">Fit:</span>}
      {quickFitText}
    </p>
  );
};

export default QuickFit;
